var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInovatoveSol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.753,
    height: 158,
    viewBox: "0 0 158.753 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(-18825.5 -1587.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solution_1_",
    "data-name": "solution (1)",
    transform: "translate(18825.5 1587.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M218.755,351.2a2.319,2.319,0,0,1-1.469-4.115l16.643-13.61a4.459,4.459,0,0,0,1.425-6.092,4.391,4.391,0,0,0-5.925-1.5l-33.773,20.534a2.319,2.319,0,0,1-1.836.25L164.245,338.3a2.319,2.319,0,0,1-.268-4.37l22.256-9.356a5.59,5.59,0,0,0-4.215-10.354l-15.69,6.106a2.319,2.319,0,0,1-2.054-.185c-18.647-11.443-30.963,2.015-31.478,2.593a2.335,2.335,0,0,1-1.737.782h-9.239a2.319,2.319,0,1,1,0-4.639h8.28c3.316-3.143,16.9-14.091,35.6-3.286l14.635-5.7a10.229,10.229,0,0,1,7.7,18.95l-16.155,6.791,22.228,6.285,32.964-20.041a9.044,9.044,0,0,1,9.628,15.3l-16.48,13.488A2.31,2.31,0,0,1,218.755,351.2Z",
    transform: "translate(-82.546 -213.64)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M195.8,460.078a2.317,2.317,0,0,1-.249-.013l-57.32-6.185-16.412.013a2.319,2.319,0,1,1,0-4.638H138.48l56.6,6.094,18.557-15.174a2.319,2.319,0,1,1,2.936,3.591l-19.308,15.789A2.32,2.32,0,0,1,195.8,460.078Z",
    transform: "translate(-82.546 -303.751)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M358.435,354.888a2.32,2.32,0,0,1-2.1-3.311l11.873-25.109a9.044,9.044,0,0,1,16.459,7.473l-1.8,5.812a2.319,2.319,0,1,1-4.428-1.382l1.874-6a4.459,4.459,0,0,0-2.163-5.87,4.392,4.392,0,0,0-5.771,2.01L360.534,353.56A2.32,2.32,0,0,1,358.435,354.888Z",
    transform: "translate(-245.993 -222.101)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M39.273,376.42H2.319A2.319,2.319,0,0,1,0,374.1V318.438a2.319,2.319,0,0,1,2.319-2.319H39.273a2.319,2.319,0,0,1,2.319,2.319v20.719a2.32,2.32,0,0,1-2.105,2.31,2.32,2.32,0,0,1,2.105,2.31V374.1A2.319,2.319,0,0,1,39.273,376.42ZM4.639,371.781H36.954V343.776a2.32,2.32,0,0,1,2.105-2.31,2.32,2.32,0,0,1-2.105-2.31v-18.4H4.639Z",
    transform: "translate(0 -218.42)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1432",
    "data-name": "Ellipse 1432",
    d: "M1.352-7.5A8.862,8.862,0,0,1,10.2,1.352,8.862,8.862,0,0,1,1.352,10.2,8.862,8.862,0,0,1-7.5,1.352,8.862,8.862,0,0,1,1.352-7.5Zm0,13.065A4.213,4.213,0,1,0-2.861,1.352,4.218,4.218,0,0,0,1.352,5.565Z",
    transform: "translate(19.444 136.084)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    d: "M-5.181-7.5H25.743a2.319,2.319,0,0,1,2.319,2.319V5.849a2.319,2.319,0,0,1-2.319,2.319H-5.181A2.319,2.319,0,0,1-7.5,5.849V-5.181A2.319,2.319,0,0,1-5.181-7.5Zm28.6,4.639H-2.861V3.529H23.423Z",
    transform: "translate(93.622 70.565)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    d: "M-5.181-7.5H13.373a2.319,2.319,0,0,1,2.319,2.319V6.586a2.319,2.319,0,0,1-2.319,2.319H-5.181A2.319,2.319,0,0,1-7.5,6.586V-5.181A2.319,2.319,0,0,1-5.181-7.5ZM11.054-2.861H-2.861V4.267H11.054Z",
    transform: "translate(99.807 81.594)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M280.681,67.883H249.8a2.319,2.319,0,0,1-2.319-2.319V58.088a31.668,31.668,0,1,1,46.757-13.457,2.319,2.319,0,0,1-2.99,1.214,2.319,2.319,0,0,1,.629,3.165A32.039,32.039,0,0,1,283,58.087v7.477A2.319,2.319,0,0,1,280.681,67.883Zm-28.566-4.639h26.246V56.828a2.319,2.319,0,0,1,1.1-1.971,27.343,27.343,0,0,0,8.516-8.362,2.32,2.32,0,0,1,2.814-.895,2.32,2.32,0,0,1-.8-2.842,27.042,27.042,0,1,0-38.972,12.1,2.319,2.319,0,0,1,1.1,1.971Z",
    transform: "translate(-161.336 -0.18)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M304.084,97.664a2.312,2.312,0,0,1-1.64-.679l-8.951-8.951a2.319,2.319,0,0,1,3.28-3.28l7.311,7.311,11.48-11.48a2.319,2.319,0,0,1,3.28,3.28l-13.12,13.12A2.312,2.312,0,0,1,304.084,97.664Z",
    transform: "translate(-202.265 -55.252)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    d: "M8.7-2.861H-5.181A2.319,2.319,0,0,1-7.5-5.181,2.319,2.319,0,0,1-5.181-7.5H8.7a2.319,2.319,0,0,1,2.319,2.319A2.319,2.319,0,0,1,8.7-2.861Z",
    transform: "translate(56.552 37.805)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    "data-name": "Line 21",
    d: "M-5.179,4.076A2.318,2.318,0,0,1-7.19,2.916,2.319,2.319,0,0,1-6.341-.252L5.677-7.19a2.319,2.319,0,0,1,3.168.849A2.319,2.319,0,0,1,8-3.173L-4.022,3.765A2.309,2.309,0,0,1-5.179,4.076Z",
    transform: "translate(63.137 57.255)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_22",
    "data-name": "Line 22",
    d: "M6.834,4.076a2.308,2.308,0,0,1-1.157-.311L-6.341-3.173A2.319,2.319,0,0,1-7.19-6.341,2.319,2.319,0,0,1-4.022-7.19L8-.252A2.32,2.32,0,0,1,6.834,4.076Z",
    transform: "translate(142.106 58.829)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_23",
    "data-name": "Line 23",
    d: "M8.7-2.861H-5.181A2.319,2.319,0,0,1-7.5-5.181,2.319,2.319,0,0,1-5.181-7.5H8.7a2.319,2.319,0,0,1,2.319,2.319A2.319,2.319,0,0,1,8.7-2.861Z",
    transform: "translate(147.738 39.622)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    "data-name": "Line 24",
    d: "M-5.179,4.077A2.318,2.318,0,0,1-7.19,2.917,2.319,2.319,0,0,1-6.341-.252L5.677-7.19a2.319,2.319,0,0,1,3.168.849A2.319,2.319,0,0,1,8-3.173L-4.022,3.766A2.309,2.309,0,0,1-5.179,4.077Z",
    transform: "translate(143.014 13.236)",
    fill: "#2979ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_25",
    "data-name": "Line 25",
    d: "M6.834,4.077a2.308,2.308,0,0,1-1.157-.311L-6.341-3.173A2.319,2.319,0,0,1-7.19-6.341,2.319,2.319,0,0,1-4.022-7.19L8-.252A2.32,2.32,0,0,1,6.834,4.077Z",
    transform: "translate(64.045 11.662)",
    fill: "#2979ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInovatoveSol);
export default __webpack_public_path__ + "static/media/inovatoveSol.136de0bb6b86d623abfdacda04811ec3.svg";
export { ForwardRef as ReactComponent };